import * as v from 'valibot';

import { paginatedSchema } from '../_core.model';

const SEARCH_CRITERIA_MESSAGE = 'At least one of Product Code or Product Description is required';

const productSearchFieldsSchema = v.object({
  productCode: v.optional(v.string()),
  productDesc: v.optional(v.string()),
});

export const productSearchFormSchema = v.pipe(
  productSearchFieldsSchema,
  v.forward(
    v.partialCheck(
      [['productCode'], ['productDesc']],
      (data) => Boolean(data.productCode || data.productDesc),
      SEARCH_CRITERIA_MESSAGE,
    ),
    ['productCode'],
  ),
);

export const productSchema = v.object({
  id: v.number(),
  productCode: v.nullish(v.string()),
  productDesc: v.nullish(v.string()),
  productUnitMeasure: v.nullish(v.string()),
});

// TODO: swagger declares a bare array, every other master data vertical parses `{ items, totalCount }` —
// drop the union once the real response shape is confirmed.
export const productsResponseSchema = v.union([v.array(productSchema), paginatedSchema(productSchema)]);

export const productSearchParamsSchema = v.object({
  ...productSearchFieldsSchema.entries,
  limit: v.optional(v.pipe(v.number(), v.minValue(0)), 10),
  offset: v.optional(v.pipe(v.number(), v.minValue(0)), 0),
  sorting: v.optional(v.string()),
});

export type ProductSearchFormValues = v.InferOutput<typeof productSearchFormSchema>;
export type ProductsParams = v.InferOutput<typeof productSearchParamsSchema>;
export type ProductItem = v.InferOutput<typeof productSchema>;
export type ProductsResponse = v.InferOutput<typeof productsResponseSchema>;
export type ProductRow = {
  id: string;
  productCode: string;
  productDesc: string;
  productKey: number;
  productUnitMeasure: string;
};
export type Products = ProductRow[];
export type ProductsApi = { data: Products; total: number };
